import { Skeleton } from "@/components/ui/skeleton";

export function PageLoader({ rows = 8 }) {
  return (
    <div className="animate-in fade-in-0 duration-300" data-testid="page-loader">
      <Skeleton className="h-8 w-64 mb-2" />
      <Skeleton className="h-4 w-96 mb-6" />
      <div className="flex gap-2 mb-4"><Skeleton className="h-8 w-72" /><div className="flex-1" /><Skeleton className="h-8 w-32" /><Skeleton className="h-8 w-24" /></div>
      <div className="rounded-md border border-border overflow-hidden">
        <Skeleton className="h-10 w-full rounded-none" />
        {Array.from({ length: rows }).map((_, i) => <Skeleton key={i} className="h-11 w-full rounded-none border-t border-border/60" style={{ opacity: 1 - i * 0.08 }} />)}
      </div>
    </div>
  );
}

export function TableSkeleton({ rows = 6, cols = 6 }) {
  return (
    <div className="p-2 space-y-2" data-testid="table-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-3">{Array.from({ length: cols }).map((_, j) => <Skeleton key={j} className="h-5 flex-1" />)}</div>
      ))}
    </div>
  );
}

// KPI cards + chart blocks placeholder for dashboards.
export function DashboardSkeleton({ cards = 5 }) {
  return (
    <div className="animate-in fade-in-0 duration-300" data-testid="dashboard-skeleton">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 mb-6">{Array.from({ length: cards }).map((_, i) => <Skeleton key={i} className="h-28" />)}</div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4"><Skeleton className="h-64" /><Skeleton className="h-64" /><Skeleton className="h-64" /></div>
    </div>
  );
}

// Compact rows placeholder for dialogs / small panels.
export function LinesSkeleton({ rows = 3, className = "" }) {
  return <div className={`space-y-2 py-2 ${className}`} data-testid="lines-skeleton">{Array.from({ length: rows }).map((_, i) => <Skeleton key={i} className="h-4 w-full" style={{ opacity: 1 - i * 0.2 }} />)}</div>;
}

export function EmptyState({ icon: Icon, title = "Nothing here yet", hint, action, testid = "empty-state" }) {
  return (
    <div className="flex flex-col items-center justify-center py-14 text-center" data-testid={testid}>
      {Icon && <div className="h-11 w-11 rounded-md bg-muted flex items-center justify-center text-muted-foreground mb-3"><Icon size={22} /></div>}
      <div className="text-sm font-semibold">{title}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1 max-w-sm">{hint}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
